import { render, staticRenderFns } from "./Permission404.vue?vue&type=template&id=1c4440bf&"
import script from "./Permission404.vue?vue&type=script&lang=js&"
export * from "./Permission404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports